import { useEffect, useRef, useState } from "react";
import { Pause, Play } from "lucide-react";
import { cx } from "../../lib/cx";

/**
 * A silent, looping video file behind a hero: no player chrome, starts
 * with the page, with the poster painted until the first frame. A small,
 * quiet pause/play icon sits in the corner (moving content needs a pause
 * control, WCAG 2.2.2). Reduced-motion visitors get the poster until they
 * press play.
 */
export default function LoopVideo({ src, poster, className }) {
  const video = useRef(null);
  const [playing, setPlaying] = useState(true);

  useEffect(() => {
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) {
      video.current?.pause();
      setPlaying(false);
    }
  }, []);

  function toggle() {
    if (playing) video.current?.pause();
    else video.current?.play();
    setPlaying(!playing);
  }

  return (
    <div className={cx("bg-video", className)}>
      <video
        ref={video}
        src={src}
        poster={poster}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        aria-hidden="true"
        className="absolute inset-0 size-full object-cover"
      />
      <button
        type="button"
        className="video-pause"
        onClick={toggle}
        aria-label={playing ? "Pause background video" : "Play background video"}
        title={playing ? "Pause video" : "Play video"}
      >
        {playing ? (
          <Pause size={14} fill="currentColor" aria-hidden="true" />
        ) : (
          <Play size={14} fill="currentColor" aria-hidden="true" />
        )}
      </button>
    </div>
  );
}
